import styled from 'styled-components';
import { StyleVars, typeScale } from 'core/utils';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 16px;
	background-color: #F2F2F2;
	padding: 10px;

	svg {
		margin-right: 5px;
		width: 30%;

		@media (max-width: ${StyleVars.screenCjDesktopSm}) {
			width: 40%;
		}

		@media (max-width: ${StyleVars.screenCjTablet}) {
			width: 50%;
		}

		@media (max-width: ${StyleVars.screenSm}) {
			width: 100%;
			margin-top: ${typeScale(1)};
			padding: 0;
		}

		@media (max-width: ${StyleVars.screenXsm}) {
			width: 120px;
		}
	}
`;

export const Text = styled.p`
	margin: 0;
	font-weight: 400;
	font-size: 14px;
	padding: 0px;

	& span {
		font-weight: 700;
		font-size: 14px;
	}
`;